import React, { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import { Table, Button, Col, Row, Modal } from "reactstrap"
import api from "API/Api"
import SweetAlert from "react-bootstrap-sweetalert"
import loader from "./../../assets/loading/loader.gif"
import { usePermissions } from "API/PermissionContext"

const CanTypes = props => {
  const { canAdd, canEdit, canDelete, MODULE } = usePermissions()
  const MID = MODULE.CONFIGURATIONS
  const [canTypes, setCanTypes] = useState([])
  const [cell, setCell] = useState("")
  const [canId, setCanId] = useState("")
  const [confirm_alert, setconfirm_alert] = useState(false)
  const [success_dlg, setsuccess_dlg] = useState(false)
  const [dynamic_title, setdynamic_title] = useState("")
  const [dynamic_description, setdynamic_description] = useState("")
  const [search, setSearch] = useState({canTypename:'',canTypeWeight:''})
  const [checkedItems, setCheckedItems] = useState(new Array(canTypes.length).fill(false))
  const [parentChecked, setParentChecked] = useState(false)
  const [load,setLoad] = useState(false)
  const [confirm_multiple_alert, setconfirm_multiple_alert] = useState(false)
  const [showFilter, setShowFilter] = useState(false)

  useEffect(() => { fetchData() }, [load])

  const fetchData = async () => {
    const response = await api.get("can-types")
    setCanTypes(Array.isArray(response.data.data) ? response.data.data : response.data.data?.data || [])
  }
  const fetchDelete = async () => {
    const deleteCan = await api.delete("delete-can/" + canId)
    if (deleteCan.data.success === true) setLoad(!load)
  }

  const handleCheckboxChange = (i) => {
    const newCheckedItems = [...checkedItems]
    newCheckedItems[i] = !newCheckedItems[i]
    setCheckedItems(newCheckedItems)
    setParentChecked(newCheckedItems.every((item) => item))
  }
  const handleParentCheckboxChange = () => {
    const newParentChecked = !parentChecked
    setParentChecked(newParentChecked)
    const newCheckedItems = new Array(canTypes.length).fill(newParentChecked)
    setCheckedItems(newCheckedItems)
  }
  const getSelectedUnitIds = async () => {
    const selectedIds = canTypes.map((canType, i) => (checkedItems[i] ? canType.id : null)).filter((id) => id !== null)
    const multipleDeleteUnit = await api.post("delete-multiple-cantypes", { items: selectedIds })
    if (multipleDeleteUnit.data.success === true) setLoad(!load)
  }
  const removeFilter = () => {
    setSearch({ canTypename:'',canTypeWeight:''})
    setShowFilter(!showFilter)
  }

  return (
    <>
      <div className="dashBody">
        {canDelete(MID) && (
          <button className="delete-button" onClick={() => {setconfirm_multiple_alert(true)}}>
            <i className="fa fa-trash"></i>
          </button>
        )}
        <button className="filter_rel btn btn-primary" onClick={() => removeFilter()}>
          <i className="fa fa-filter"></i>
          { showFilter && <i className="rel_filter_ban fa fa-ban"></i> }
        </button>
        <div className="font-size-18 mb-0 dashHeader">
          <Row>
            <Col md={6}><h4>Can Types</h4></Col>
            <Col md={6} style={{ textAlign: "right" }}>
              {canAdd(MID) && (
                <Link className="dashBtn" to="/add-can-type">
                  <i className="fas fa-plus-square "></i> <b> Add New</b>
                </Link>
              )}
            </Col>
          </Row>
        </div>
        <div className="table-responsive">
          <Table className="table mb-0 dairyTbl" id="canTypes">
            <thead>
              <tr>
                <th><input type="checkbox" checked={parentChecked} onChange={handleParentCheckboxChange} /></th>
                <th>S.No</th>
                <th>Can Type Name</th>
                <th>Can Weight</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              { showFilter ? (
                <tr>
                  <td></td><td></td>
                  <td><input type="text" className="form-control material_unit_type_sub"
                    onChange={e => setSearch({...search, canTypename : e.target.value})}
                    value={search.canTypename} placeholder="Search by typename" /></td>
                  <td><input type="text" className="form-control material_unit_type_sub"
                    onChange={e => setSearch({...search, canTypeWeight : e.target.value})}
                    value={search.canTypeWeight} placeholder="Search by weight" /></td>
                  <td><a className="btn btn-block btn-success applyFilter" title="Apply Filter"><i className="fa fa-search"></i> Apply </a></td>
                </tr>
              ) : null}
              {canTypes.length > 0 ? (
                canTypes.filter(item =>
                  (item.canName || "").toLowerCase().includes(search.canTypename.toLowerCase()) &&
                  (item.weight || "").toLowerCase().includes(search.canTypeWeight.toLowerCase())
                )
                .map((can, i) => (
                  <tr key={i}>
                    <td><input type="checkbox" checked={checkedItems[i]} onChange={() => handleCheckboxChange(i)} /></td>
                    <td>{i + 1}</td>
                    <td>{can.canName}</td>
                    <td>{can.weight}</td>
                    <td>
                      {canEdit(MID) && <Link to={"/edit-can-type/" + can.id}><i className="fas fa-edit icons icon-edit"></i></Link>}
                      {canDelete(MID) && <i className="fas fa-trash-alt icons icon-delete"
                        onClick={() => { setCanId(can.id); setCell(i + 1); setconfirm_alert(true) }}></i>}
                    </td>
                  </tr>
                ))
              ) : (
                <tr><td colSpan={5}><img className="loaderImg" src={loader} alt="loading" /></td></tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
      {confirm_alert && (
        <SweetAlert title="Are you sure?" warning showCancel confirmBtnBsStyle="success" cancelBtnBsStyle="danger"
          onConfirm={() => { fetchDelete(); setconfirm_alert(false); setsuccess_dlg(true); setdynamic_title("Deleted"); setdynamic_description("Your file has been deleted.") }}
          onCancel={() => setconfirm_alert(false)}>You won't be able to revert this!</SweetAlert>
      )}
      {confirm_multiple_alert && (
        <SweetAlert title="Are you sure?" warning showCancel confirmBtnBsStyle="success" cancelBtnBsStyle="danger"
          onConfirm={() => { getSelectedUnitIds(); setconfirm_multiple_alert(false); setsuccess_dlg(true); setdynamic_title("Deleted"); setdynamic_description("Your files has been deleted.") }}
          onCancel={() => setconfirm_multiple_alert(false)}>You won't be able to revert this!</SweetAlert>
      )}
      {success_dlg && (
        <SweetAlert success title={dynamic_title} onConfirm={() => setsuccess_dlg(false)}>{dynamic_description}</SweetAlert>
      )}
    </>
  )
}

export default CanTypes
